import { render } from "./ThemeDisplay.vue?vue&type=template&id=2c28119c&scoped=true&ts=true"
import script from "./ThemeDisplay.vue?vue&type=script&lang=ts"
export * from "./ThemeDisplay.vue?vue&type=script&lang=ts"

import "./ThemeDisplay.vue?vue&type=style&index=0&id=2c28119c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c28119c"]])

export default __exports__